module.exports = __webpack_public_path__ + "img/threeOfKinds.8598933a.png";